import React, { useState, useEffect, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import PaymentTrackActions from "../../../../Redux/transition/payment-track/payment-track.reducer";
import { useSelector, useDispatch } from "react-redux";
import DefMembershipActions from "../../../../Redux/actions/defMembership-actions";
import PaymentScheduleActions from "../../../../Redux/transition/payment-schedule/payment-schedule.reducer";
import SubscriberActions from "../../../../Redux/transition/subscriber/subscriber.reducer";
// imports from other libraries ;
import { Button } from "primereact/button";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
//imports from styles
import "../../../../Styles/pages/subscriptionDetail.scss"
import "../../../../Styles/components/sti.css"
import "../../../../Styles/pages/inviteSubscriber.scss"
import "../../../../Styles/pages/invitation.scss"
import "../../../../Styles/pages/customers.scss"
import MarkAsPaid from "../../../../Components/MarkAsPaid";
import CustomDataTable from "../../../../Components/CustomDataTable";
import { Paginator } from 'primereact/paginator';
import { useDateFormatter } from "../../../../Components/FormatDateTime";
import { FormatCurrency, useCurrencyConstants } from '../../../../Components/CurrencyFormatter';
import AutoBillingBadge from "../../../../Components/AutoBillingBadge";

const SUBSCRIPTION_DETAIL_MOBILE_BREAKPOINT = 1050;

const TransactionsTabs = (props) => {

    const { formatDate, formatDateTime } = useDateFormatter();
    const { currencyFormat, currencySymbol } = useCurrencyConstants();

    const navigate = useNavigate();
    const { t } = useTranslation("common");
    const [activeTab, setActiveTab] = useState(0);
    const [displayBasic, setDisplayBasic] = useState(false);
    const [isMobileStack, setIsMobileStack] = useState(
        () => typeof window !== "undefined" && window.innerWidth <= SUBSCRIPTION_DETAIL_MOBILE_BREAKPOINT
    );
    const [state, setState] = useState({
        subscriberObjects: {},
        paymentTracks: [],
        paymentMissedSchedules: [],
        scheduleId: null,
        scheduledFor: null,
        date: null,
        paymentData: [],
        marking: true,
        cancelled: false,
        response: null,
        paused: false,
        tabSelected: false,
        id: null,
        key: false,
        page: 0,
        size: 15,
        sort: 'receivedAt,desc',
        sortOrder: 'scheduledFor,desc',
        sortBy: "externallyReceivedOn,desc",
        subsExternalPayments: [],
        flex: null,
        externallyReceivedPayments: {},
        externalTabSelected: false,
        first: 0,
        missedSchedules: {},
        collectedPayments: {},
    });

    let { id } = useParams();

    const defMembership = useSelector((state) => state.defMembership.defMembership)
    const externalPaymentTracks = useSelector((state) => state.paymentTracks.subsPayments)
    const fetchingMissed = useSelector((state) => state.paymentSchedules.fetchingMissed)
    const paymentSchedulesMissed = useSelector((state) => state.paymentSchedules.paymentSchedulesMissed)
    const paymentTracks = useSelector((state) => state.paymentTracks.paymentTracks)
    const fetchingTracks = useSelector((state) => state.paymentTracks.fetchingAll)
    const fetchingSubsExternalPayments = useSelector((state) => state.paymentTracks.fetchingSubsExternalPayments)


    const dispatch = useDispatch()
    const getSubscriber = useCallback((subscriberId) => { dispatch(SubscriberActions.subscriberRequest(subscriberId)) }, [dispatch])
    const getMembership = useCallback(() => { dispatch(DefMembershipActions.defMembershipRequest()) }, [dispatch])
    const getAllPaymentSchedules = useCallback((subscriberId, options) => { dispatch(PaymentScheduleActions.paymentScheduleAllRequest(subscriberId, options)) }, [dispatch])
    const getMissedPaymentSchedules = useCallback((subscriberId, options) => { dispatch(PaymentScheduleActions.paymentScheduleMissedRequest(subscriberId, options)) }, [dispatch])
    const getAllPaymentTracks = useCallback((subscriberId, options) => { dispatch(PaymentTrackActions.paymentTrackAllRequest(subscriberId, options)) }, [dispatch])
    const getSubsExternalPayments = useCallback((businessId, subId, options) => { dispatch(PaymentTrackActions.subscriberExternalPaymentsRequest(businessId, subId, options)) }, [dispatch])


    useEffect(() => {
        const mediaQuery = window.matchMedia(`(max-width: ${SUBSCRIPTION_DETAIL_MOBILE_BREAKPOINT}px)`);
        const onBreakpointChange = (event) => setIsMobileStack(event.matches);
        onBreakpointChange(mediaQuery);
        mediaQuery.addEventListener("change", onBreakpointChange);
        return () => mediaQuery.removeEventListener("change", onBreakpointChange);
    }, []);

    useEffect(() => {
        if (!defMembership) {
            getMembership();
        }
        if (defMembership) {
            getSubsExternalPayments(defMembership.business?.id, id, { page: state.page, sort: state.sortBy, size: state.size })
            getMissedPaymentSchedules(id, { page: state.page, sort: state.sortOrder, size: state.size })
            getAllPaymentTracks(id, { page: state.page, sort: state.sort, size: state.size });
        }
        // eslint-disable-next-line
    }, [])

    useEffect(() => {
        if (externalPaymentTracks) {
            setState((state) => { return { ...state, externallyReceivedPayments: externalPaymentTracks } })
        }
        if (paymentTracks) {
            setState((state) => { return { ...state, collectedPayments: paymentTracks } })
        }
        if (paymentSchedulesMissed) {
            setState((state) => { return { ...state, missedSchedules: paymentSchedulesMissed } })
        }

    }, [externalPaymentTracks, state.externallyReceivedPayments, paymentSchedulesMissed, paymentTracks])

    const transactionsIdTemplate = (rowData) => {
        return <p className="transactions_data detail-navigation font-bold text-left" onClick={() => {
            navigate(`/payments/detail/${rowData.id}`)
        }}>{rowData.reference}</p>
    }

    const loading = fetchingMissed || fetchingTracks || fetchingSubsExternalPayments

    const receivedAtTemplate = (rowData, e) => {
        return (<div>
            {rowData.receivedAt && <>
                <p className="date-format">{formatDateTime(rowData.receivedAt)} </p>
            </>}
        </div>)
    }

    const paymentTemplate = (rowData, e) => {
        return (<div>
            {(rowData.paymentMode) ?
                <p className="transactions_data text-left"> {rowData.paymentMode} </p> : "--"
            }
        </div>)
    }

    const markActionTemplate = (rowData) => {
        if (rowData) {
            return (rowData.subscription?.status === "ACTIVE" ? < Button
                label={t("subscriber.paid")}
                style={{ color: "#008dd5" }}
                className="p-button-warning p-button-rounded p-button-text mr-2 customerAction"
                onClick={() => {
                    setDisplayBasic(true)
                    setState((state) => ({
                        ...state,
                        id: rowData.id,
                        scheduledFor: rowData.scheduledFor,
                        flex: rowData.subscription.plan?.flex
                    }));
                }}
            /> : "")
        }
    }

    const paymentIdTemplate = (rowData) => {
        if (rowData) {
            return <div>
                <span>
                    {rowData.extReceivedRef || rowData.id || "--"}
                </span>
            </div>
        }
    }
    const occurredOnTemplate = (rowData) => {
        if (rowData) {
            return <div style={{ textAlign: 'left' }}>
                <span className='tier-date'>
                    {formatDate(rowData.externallyReceivedOn)}
                </span>
            </div>
        }
    }

    const collected_template = (tier) => {
        if (tier) {
            return <div className="col_amounts" style={{ flexDirection: "column" }}>
                <FormatCurrency
                    amount={tier?.amount}
                    currencySymbol={currencySymbol}
                    currencyFormat={currencyFormat}
                    className="collected_amount mb-1"
                />
                {
                    tier.setupAmount !== null ? <div>
                        <div style={{ display: "flex" }}>
                            <p className="mb-1">
                                <span style={{ color: "#000", fontWeight: "bold", fontSize: "12px" }}>{t("subscriber.amount")}{":"}</span>
                                <FormatCurrency
                                    amount={tier.originalAmount}
                                    currencySymbol={currencySymbol}
                                    currencyFormat={currencyFormat}
                                    className="tier-original-amount"
                                />
                            </p>
                        </div>
                        <div>
                            <div className="setup_fee_div" id="setup-m-b">
                                <span className="setup_fee_tag">{t("common.setup_fee_label")}</span>
                                <FormatCurrency
                                    amount={tier.setupAmount}
                                    currencySymbol={currencySymbol}
                                    currencyFormat={currencyFormat}
                                    className="setup_fee_value"
                                />
                            </div>
                        </div>
                    </div> : ""
                }
            </div>
        }
    }

    const costTemplate = (rowData) => {
        if (rowData) {
            return <div>
                <div style={{ textAlign: 'left' }}>
                    {
                        rowData.subscription?.plan?.flex === true ?
                            <div>
                                <span style={{ display: "block", marginBottom: "0.5rem" }}>{t("products.flexible_amount")}</span>
                                {rowData.extReceivedAmount ?
                                    <FormatCurrency
                                        amount={rowData.extReceivedAmount}
                                        currencySymbol={currencySymbol}
                                        currencyFormat={currencyFormat}
                                        className="transactions_data"
                                    /> : t("amount_fixed")}
                            </div>
                            :
                            <FormatCurrency
                                amount={rowData.cost}
                                currencySymbol={currencySymbol}
                                currencyFormat={currencyFormat}
                                className="transactions_data"
                            />
                    }
                </div>
            </div>
        }
    }

    const notesTemplate = (rowData) => {
        if (rowData) {
            return <div style={{ textAlign: 'left' }}>
                {
                    rowData.extReceivedNotes ?
                        <div>
                            <p> {rowData.extReceivedNotes}</p>
                        </div> : "--"
                }
            </div>
        }
    }

    const missedSheduleBodyTemplate = (rowData) => {
        return <div>
            <p className={`text-left failed_scheduleStatus subscription-status status-${rowData.status}`}>{rowData.status}</p>
            <p className="cust-scheduledFor text-left">{t("subscriber.scheduled_for")}</p>
            {(rowData.scheduledFor) ? <p className="text-left mt-0 mb-2 time-style">{formatDateTime(rowData.scheduledFor)}</p> : "--"}

        </div>
    }

    const paymentSubscriptionBodyTemplate = (rowData) => {
        if (rowData?.subscription) {
            return <div>
                <div className="subscriptionBodyTemplate" style={{ alignItems: "flex-start" }}>
                    {
                        rowData.subscription.subscriberReference !== null ?
                            <p style={{ marginBottom: "15px" }} className="reference-text detail-navigation" id="planName">
                                {rowData.subscription.subscriberReference}
                            </p>
                            : ""
                    }
                    {
                        rowData.subscription.plan?.name ?
                            <div className="flex align-items-center gap-2">
                                <span className="detail-navigation tier-name-content"
                                    onClick={() => {
                                        navigate(`/products/plan/detail/${rowData.subscription.plan.id}`)
                                    }}
                                >
                                    {rowData.subscription.plan.name !== null ? rowData.subscription.plan.name : ""}
                                </span>
                                <AutoBillingBadge collectionMode={rowData.subscription.plan.collectionMode} />
                            </div> : null
                    }
                    {
                        rowData.subscription?.plan?.billingPeriod ?
                            <span className="plan-group-text">
                                {rowData.subscription.plan.billingPeriod !== null ? t(`product.${rowData.subscription.plan.billingPeriod.toLowerCase()}`) : ""}
                            </span> : null
                    }
                    {
                        rowData.subscription.plan?.groupName &&
                        <span className="plan-text detail-navigation hov"
                            onClick={() => {
                                navigate(`/products/detail/${rowData.subscription.plan.groupId}`)
                            }}
                        >
                            {rowData.subscription.plan.groupName}
                        </span>
                    }
                </div >
            </div >
        }
    }

    const successColumns = [
        {
            field: "transaction_id",
            header: () => { return <p className="transactions_header">{t("subscriber.reference")}</p> },
            body: transactionsIdTemplate, alignHeader: "left"
        },
        {
            field: "received_at", alignHeader: "left",
            body: receivedAtTemplate, header: () => { return <p className="transactions_header">{t("subscriber.occurred_on")}</p> }
        },
        { field: "payment_mode", body: paymentTemplate, alignHeader: "left", header: () => { return <p className="transactions_header">{t("subscriber.payment_method")} </p> } },
        {
            field: "amount paid", header: () => { return <p className="amount-header">{t("subscriber.amount_paid")} </p> },
            body: collected_template, headerClassName: "subsTemplate-header", alignHeader: "left"
        },
        {
            field: "fees", alignHeader: "left", header: () => { return <p className="transactions_header">{t("subscriber.service_fee")} </p> },
            body: (rowData) => <FormatCurrency
                amount={rowData.fees}
                currencySymbol={currencySymbol}
                currencyFormat={currencyFormat}
                className="text-left trans_fee"
            />
        },
        {
            field: "amount received", alignHeader: "left", header: () => { return <p className="transactions_header">{t("subscriber.amount_received")} </p> },
            body: (rowData) => <FormatCurrency
                amount={rowData.redeemable}
                currencySymbol={currencySymbol}
                currencyFormat={currencyFormat}
                className="trans_redeemable"
            />
        }
    ]
    const failedColumns = [
        { field: "status", alignHeader: "left", header: t("products.payment_schedule"), body: missedSheduleBodyTemplate },
        {
            field: "plan_amount", alignHeader: "left", header: () => { return <p className="transactions_header">{t("subscriber.plan_amount")}</p> }, body: (rowData) => (
                rowData.subscription.plan?.flex === true ? <p className="transactions_data text-left">
                    {t("products.flexible_amount")}
                </p> : <FormatCurrency
                    amount={rowData.cost}
                    currencySymbol={currencySymbol}
                    currencyFormat={currencyFormat}
                    className="transactions_data text-left"
                />
            )
        },
        { body: markActionTemplate }
    ]

    const externalPayments = [

        { field: 'id', body: paymentIdTemplate, header: t("products.ref"), sort: true, headerClassName: "amount-header", alignHeader: "left" },
        { field: 'subscriber', body: paymentSubscriptionBodyTemplate, header: t("subscriber.info"), headerClassName: "amount-header", alignHeader: "left" },
        { field: 'extReceivedOn', body: occurredOnTemplate, header: t("subscriber.occurred_on"), sort: true, headerClassName: "amount-header", alignHeader: "left" },
        { field: 'cost', body: costTemplate, header: t("dashboard.amount"), sort: true, headerClassName: "amount-header", alignHeader: "left" },
        { body: notesTemplate, header: t("subscriber.notes"), headerClassName: "amount-header", alignHeader: "left" },
    ]

    const collectedMobileSummary = (rowData) => (
        <div className="subscription-detail-mobile-summary">
            <div className="subscription-detail-mobile-section">{transactionsIdTemplate(rowData)}</div>
            <div className="subscription-detail-mobile-section">{receivedAtTemplate(rowData)}</div>
            <div className="subscription-detail-mobile-section">{paymentTemplate(rowData)}</div>
            <div className="subscription-detail-mobile-section">{collected_template(rowData)}</div>
            <div className="subscription-detail-mobile-section">
                <FormatCurrency
                    amount={rowData.fees}
                    currencySymbol={currencySymbol}
                    currencyFormat={currencyFormat}
                    className="text-left trans_fee"
                />
            </div>
            <div className="subscription-detail-mobile-section subscription-detail-mobile-section-last">
                <FormatCurrency
                    amount={rowData.redeemable}
                    currencySymbol={currencySymbol}
                    currencyFormat={currencyFormat}
                    className="trans_redeemable"
                />
            </div>
        </div>
    );

    const missedMobileSummary = (rowData) => (
        <div className="subscription-detail-mobile-summary">
            <div className="subscription-detail-mobile-section">{missedSheduleBodyTemplate(rowData)}</div>
            <div className="subscription-detail-mobile-section">
                {rowData.subscription.plan?.flex === true ? (
                    <p className="transactions_data text-left">{t("products.flexible_amount")}</p>
                ) : (
                    <FormatCurrency
                        amount={rowData.cost}
                        currencySymbol={currencySymbol}
                        currencyFormat={currencyFormat}
                        className="transactions_data text-left"
                    />
                )}
            </div>
            <div className="subscription-detail-mobile-section subscription-detail-mobile-actions subscription-detail-mobile-section-last">
                {markActionTemplate(rowData)}
            </div>
        </div>
    );

    const externalMobileSummary = (rowData) => (
        <div className="subscription-detail-mobile-summary">
            <div className="subscription-detail-mobile-section">{paymentIdTemplate(rowData)}</div>
            <div className="subscription-detail-mobile-section">{paymentSubscriptionBodyTemplate(rowData)}</div>
            <div className="subscription-detail-mobile-section">{occurredOnTemplate(rowData)}</div>
            <div className="subscription-detail-mobile-section">{costTemplate(rowData)}</div>
            <div className="subscription-detail-mobile-section subscription-detail-mobile-section-last">
                {notesTemplate(rowData)}
            </div>
        </div>
    );

    const tabs = [{
        label: t('collected'), value: state.collectedPayments, columns: successColumns, count: props.payments?.length, index: 0
    },
    {
        label: t('missed'), value: state.missedSchedules, columns: failedColumns, count: props.missed?.length, index: 1
    },
    {
        label: t('external'), value: state.externallyReceivedPayments?.content || [], columns: externalPayments, count: state.externallyReceivedPayments?.totalElements, index: 2
    }];

    const getDisplayColumns = (tab) => {
        if (!isMobileStack) {
            return tab.columns;
        }

        const mobileBody = tab.index === 0
            ? collectedMobileSummary
            : tab.index === 1
                ? missedMobileSummary
                : externalMobileSummary;

        return [{
            field: "mobileSummary",
            header: tab.label,
            body: mobileBody,
            className: "subscription-detail-mobile-summary-column",
        }];
    };

    const totalRecords =
        tabs[activeTab].index === 0
            ? props.collectedPaymentsCount
            : tabs[activeTab].index === 1
                ? props.missedSchedulesCount
                : state.externallyReceivedPayments?.totalElements;


    const onChange = (e) => {
        if (e.pageCount <= 1) {
            return;
        }
        else if (tabs[activeTab].index === 0) {
            getAllPaymentTracks(id, { page: e.page, sort: state.sort, size: state.size })
            setState((state) => ({ ...state, first: e.first, page: state.page }));
        }
        else if (tabs[activeTab].index === 1) {
            getMissedPaymentSchedules(id, { page: e.page, sort: state.sortOrder, size: state.size })
            setState((state) => ({ ...state, first: e.first, page: state.page }));
        }
        else {
            getSubsExternalPayments(defMembership.business?.id, id, { page: e.page, sort: state.sortOrder, size: state.size })
            setState((state) => ({ ...state, first: e.first, page: state.page }));
        }
    }

    const onTabChange = () => {
        if (tabs[activeTab].index === 0) {
            getAllPaymentTracks(id, { page: state.page, sort: state.sort, size: state.size })
        } else if (tabs[activeTab].index === 1) {
            getMissedPaymentSchedules(id, { page: state.page, sort: state.sort, size: state.size })
        } else {
            getSubsExternalPayments(defMembership.business?.id, id, { page: state.page, sort: state.sortOrder, size: state.size })
        }
    }

    return (
        <div className="subscription-detail-screen">
            <MarkAsPaid displayDialog={displayBasic} onHide={() => { setDisplayBasic(false) }}
                scheduleId={state.id}
                isFlexTrue={state.flex}
                scheduledFor={state.scheduledFor}
                callbackFunctions={() => {
                    getSubscriber(id);
                    getSubsExternalPayments(defMembership.business?.id, id)
                    getAllPaymentSchedules(id);
                    getMissedPaymentSchedules(id);
                    getAllPaymentTracks(id);
                }}
            />
            <div className="title-div">
                <span className="transactions-title"> {t('subscriber.payment_transactions')}</span>
            </div>
            <div className="detail_card subscription-detail-table-card">
                <CustomDataTable
                    key={`${activeTab}-${isMobileStack}`}
                    value={tabs[activeTab].value}
                    columns={getDisplayColumns(tabs[activeTab])}
                    tabs={tabs.map(({ label, i }) => ({ label, i }))}
                    setActiveTab={setActiveTab}
                    activeTab={activeTab}
                    setState={setState}
                    tableClassName={`${tabs[activeTab].label === 'collected' ? "collected" : "not-collected"} tier_detail_data_table ml-0 subscription-detail-data-table`}
                    children={null}
                    loading={loading}
                    rows={state.size}
                    resetPage={onTabChange}
                    responsiveLayout="stack"
                    scrollable={!isMobileStack}
                    scrollHeight={isMobileStack ? undefined : "flex"}
                />
                <Paginator
                    className="subscription_detail_pagination custom-paginator subscription-detail-paginator"
                    totalRecords={totalRecords}
                    rows={state.size}
                    first={state.first}
                    onPageChange={onChange}
                />
            </div>
        </div>
    )
}
export default TransactionsTabs;